enum RemoteConfigKey {
  UnderMaintenanceDev = 'under_maintenance_dev',
  UnderMaintenanceSandbox = 'under_maintenance_sandbox',
  UnderMaintenanceStaging = 'under_maintenance_staging',
  UnderMaintenanceProduction = 'under_maintenance_production',
  DownTimeReasonDescription = 'down_time_reason_description',
  DownTimeReasonTitle = 'down_time_reason_title',
  ExpectedBackAt = 'expected_back_at'
}
export interface RemoteConfigKeyConfiguration {
  key: RemoteConfigKey;
  type: 'boolean' | 'string' | 'number' | 'json';
  showInNonProductionEnvironments?: boolean;
}
export const UnderMaintenanceConfigDev: RemoteConfigKeyConfiguration = {
  key: RemoteConfigKey.UnderMaintenanceDev,
  type: 'boolean',
  showInNonProductionEnvironments: false
};
export const DownTimeReasonDesciptionConfig: RemoteConfigKeyConfiguration = {
  key: RemoteConfigKey.DownTimeReasonDescription,
  type: 'string'
};
export const DownTimeReasonTitleConfig: RemoteConfigKeyConfiguration = {
  key: RemoteConfigKey.DownTimeReasonTitle,
  type: 'string'
};
export const ExpectedBackAtConfig: RemoteConfigKeyConfiguration = {
  key: RemoteConfigKey.ExpectedBackAt,
  type: 'string'
};
